import { Component } from 'react';

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('ErrorBoundary caught:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex flex-col items-center justify-center min-h-[300px] text-center px-6" data-testid="error-boundary">
          <div className="text-4xl font-bold text-[#8B5CF6] mb-4" style={{ fontFamily: 'Georgia, serif' }}>&pi;</div>
          <h2 className="text-white font-space font-bold text-xl mb-2">Something went wrong</h2>
          <p className="text-white/40 text-sm mb-6">An unexpected error occurred. Please try refreshing the page.</p>
          <button onClick={() => { this.setState({ hasError: false }); window.location.reload(); }}
            className="px-6 py-2 bg-[#7C3AED] text-white rounded-full text-sm font-bold hover:bg-[#6D28D9] transition-colors">
            Refresh Page
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
